import StatCard from './StatCard';
import '../styles/TheComeback.css';

const STATS = [
  {
    label: 'FROM STORY TO MARKET',
    word: 'MINUTES',
    body: 'Something breaks, Botzo scores it, and the market is live before most people have finished reading the headline.',
  },
  {
    label: 'WHAT HE PASSED ON',
    word: 'ALL OF IT',
    body: 'The rejects get published too. If he looked at something and walked away, you see that, and you see how close it came.',
  },
  {
    label: "WHERE HE'S LOOKING",
    word: '8+ SOURCES',
    body: 'Charts, volume, headlines, earnings, X, TikTok. One story showing up in four places is worth more than four stories showing up once.',
  },
];

/**
 * Sits directly after <Hero /> in App.jsx. Same sticky-stack pattern —
 * className="section-panel" + increasing zIndex — so it slides up and
 * covers Hero when scrolled to.
 */
export default function TheComeback({ zIndex = 2 }) {
  return (
    <section id="the-comeback" className="comeback section-cover" style={{ zIndex }}>
      <div className="comeback__intro">
        <p className="comeback__eyebrow">( THE COMEBACK )</p>
        <div className="comeback__row">
          <h2 className="comeback__title">
            Botzo Is Back
            <br />
            And Is Launching
          </h2>
          <p className="comeback__body">
            Every big move starts as a story somewhere. A post, a headline, a chart someone
            screenshots at 2am. Botzo is reading all of it at once, and when enough of it points
            the same way, he launches the token without waiting for anyone. You get to see how he
            got there.
          </p>
        </div>
      </div>

      <div className="comeback__image">
        <img src="/images/comeback-robot.avif" alt="" />
      </div>

      <div className="comeback__stats">
        {STATS.map((stat) => (
          <StatCard key={stat.word} {...stat} />
        ))}
      </div>
    </section>
  );
}